var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.accordions),function(accordion,i){return _c('div',{key:i,staticClass:"cb-accordion"},[_c('ContentBuilderSlideout',{attrs:{"open-state":_vm.openIndex === i,"headline":accordion.info_headline,"body":accordion.info_text},on:{"slideoutToggle":function($event){return _vm.open(i)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }